export const ACCOUNT_TYPE = {
  CHECKING: 'CheckingAccount' as const,
  SAVINGS: 'SavingsAccount' as const
};

export const BILLING_FREQUENCY = {
  ANNUAL: 'annual' as const,
  MONTHLY: 'monthly' as const
};

export const LINKS = {
  ADD_BILLING_ADDRESS: 'add-billing-address' as const,
  ADD_SERVICE_ADDRESS: 'add-service-address' as const,
  ALLIED_CHECKOUT_VALIDATION: 'allied-checkout-validation' as const,
  ALLIED_CSWB_PLANS: 'allied-cswb-plans' as const,
  APPLY_DISCOUNT: 'apply-discount' as const,
  EXPRESS_CHECKOUT: 'express-checkout' as const,
  EXPRESS_CHECKOUT_VALIDATION: 'express-checkout-validation' as const,
  GET_PLANS: 'get-plans' as const,
  MAINTENANCE_PAGE: 'maintenance' as const,
  PURCHASE: 'purchase' as const,
  RETRY_CURRENT_ADDRESS: 'retry-current-address' as const,
  RETRY_NEW_ADDRESS: 'retry-new-address' as const,
  RETRY_SUGGESTED_ADDRESS: 'retry-suggested-address' as const
};

export const PAGES = {
  CHECK_OUT: '/check-out',
  CONFIRMATION: '/confirmation',
  HOME: '/',
  MAINTENANCE: '/maintenance',
  SHOPPING: '/shopping'
};

export const COMMERCE_HUB_PAYMENT_FIELDS = {
  CARD: 'number',
  CVV: 'code',
  EXPIRATION: 'exp',
  FIRST_NAME: 'firstname',
  LAST_NAME: 'lastname'
};

export const PAYMENT_METHODS = {
  BANK_ACCOUNT: 'bank-account',
  CREDIT_CARD: 'credit-card'
};

export const COMMERCE_HUB_PAYMENT_SELECTORS = {
  [COMMERCE_HUB_PAYMENT_FIELDS.CARD]: 'cc-number',
  [COMMERCE_HUB_PAYMENT_FIELDS.CVV]: 'cc-code',
  [COMMERCE_HUB_PAYMENT_FIELDS.EXPIRATION]: 'cc-exp',
  [COMMERCE_HUB_PAYMENT_FIELDS.FIRST_NAME]: 'cc-firstname',
  [COMMERCE_HUB_PAYMENT_FIELDS.LAST_NAME]: 'cc-lastname'
};

export const STATIC_ASSETS = {
  PRIVACY_POLICY: '/NRGP_Policy_5.2022.pdf',
  TERMS_AND_CONDITIONS: '/NRGP_XOOM_CS_TC_10.22_Sample.pdf'
};

export const PAYMENT = {
  METHOD: 'method' as const
};

export const FILTERED_PLANS = {
  LINK_PLANS: 'link_plans',
  PLANS: 'plans' as const
};

export * from './states';
